import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import RecurringTask from '../../interfaces/RecurringTask.interface';

const selectRecurringTasks = (state: RootState) => state.recurringTasks;

export const selectAllRecurringTasks = () => createSelector(
  [selectRecurringTasks],
  (tasks) => {
    return tasks.recurringTasks;
  }
);

export const selectRecurringTaskById = (id: number) => createSelector(
  [selectRecurringTasks],
  (tasks) => {
    return tasks.recurringTasks.find((recurringTask: RecurringTask) => recurringTask.id === id);
  }
);

export const selectRecurringTasksByParentId = (parentTaskId: number | null) => createSelector(
  [selectRecurringTasks],
  (recurringTasks) => {
    return recurringTasks.recurringTasks.filter((recurringTask: RecurringTask) => recurringTask.parentTaskId === parentTaskId)
  }
);

export const selectUncompleteRecurringTasksByParentId = (parentTaskId: number | null) => createSelector(
  [selectRecurringTasks],
  (recurringTasks) => {
    return recurringTasks.recurringTasks.filter((recurringTask: RecurringTask) => {
      return recurringTask.parentTaskId === parentTaskId && recurringTask.permanentlyCompleted === false;
    })
  }
);

export const selectUncompleteRecurringTasks = () => createSelector(
  [selectRecurringTasks],
  (recurringTasks) => {
    return recurringTasks.recurringTasks.filter((recurringTask: RecurringTask) => {
      return recurringTask.permanentlyCompleted === false;
    })
  }
);

export const selectCompleteRecurringTasksByParentId = (parentTaskId: number | null) => createSelector(
  [selectRecurringTasks],
  (recurringTasks) => {
    return recurringTasks.recurringTasks.filter((recurringTask: RecurringTask) => {
      return recurringTask.parentTaskId === parentTaskId && recurringTask.permanentlyCompleted === true;
    })
  }
);

export const selectCompleteRecurringTasks = () => createSelector(
  [selectRecurringTasks],
  (recurringTasks) => {
    return recurringTasks.recurringTasks.filter((recurringTask: RecurringTask) => {
      return recurringTask.completed === true;
    })
  }
);
